import { getGeolocation, getCookiesConsent } from '../../utils'

const userState = {
  id: 0,
  geolocation: getGeolocation(),
  cookies: getCookiesConsent(),
  isWebConversionSended: false,
  isGclidConversionSended: false,
}

export default userState
